import * as api from "../../api/index";
import * as endpoints from "../../api/endpoints";
import * as types from "../../api/../mutation-types";

const actions = {
  getSmOrders({ commit }, payload) {
    return api.fetchFull(endpoints.SM_ORDERS, payload, commit, (response) => {
      return response;
    });
  },

  getSmOrderDetails({ commit }, payload) {
    return api.fetchFull(endpoints.SM_ORDERS_DETAILS, payload, commit, (response) => {
      return response;
    });
  },

  getSmOrderByUuid({ commit }, payload) {
    return api.fetchFull(endpoints.SM_ORDERS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  createSmOrder({ commit }, payload) {
    return api.post(endpoints.SM_ORDERS, payload, commit, (response) => {
      return response;
    });
  },

  updateSmOrder({ commit }, payload) {
    return api.put(endpoints.SM_ORDERS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  deleteSmOrder({ commit }, payload) {
    return api.remove(endpoints.SM_ORDERS + "/" + payload.uuid, payload, commit, (response) => {
      return response;
    });
  },

  getSmOrderTypes({ commit }, payload) {
    return api.fetchFull(endpoints.SM_ORDERS_TYPES, payload, commit, (response) => {
      commit(types.SET_SM_ORDER_TYPES, response.data);
      return response;
    });
  },
};

export default actions;
